import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import * as fromAddress from './+state/address.reducer';
import {EffectsModule} from '@ngrx/effects';
import {AddressEffects} from './+state/address.effects';
import {NGXLogger} from 'ngx-logger';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromAddress.ADDRESS_FEATURE_KEY,
      fromAddress.reducer
    ),
    EffectsModule.forFeature([AddressEffects]),
  ]
})
export class AddressStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
